export const getFanChatIdFromBpsId = (
  waitingRoomId: string,
  bpsId: string,
): string => `${waitingRoomId}-${bpsId}`;

// todo: use user id instead of this
export const getTalentChatId = (waitingRoomId: string): string =>
  `${waitingRoomId}-talent`;
